/**
 * inCust Corporate Off-line Site API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MessageResponse {
  /**
   * Error code
   */
  code?: number;
  /**
   * Error description
   */
  description?: string;
  /**
   * Error message
   */
  message?: string;
  /**
   * Recipien masked address (optional)
   */
  recipient?: string;
}
